import router from '@/modules/register/router'
import { useRegisterStore } from '@/modules/register/store'
import RegisterApi from '@/modules/register/service'

export default {
  router,
  service: new RegisterApi(),
  store: useRegisterStore,
}
